import React from "react"
import { type ApolloError } from "@apollo/client"
import { type Transaction } from "@digits-graphql/frontend/graphql-bearer"
import { SvgLayersTwo02 } from "@digits-shared/components/SVGIcons/line/LayersTwo02.svg"
import { AlertModal } from "@digits-shared/DesignSystem/Modals/AlertModal"
import { type FrontendTransaction } from "src/frontend/components/OS/Applications/Accounting/TransactionDetail/state/types"
import { useUnmatchTransactions } from "src/frontend/components/OS/Applications/Shared/Accounting/Matching/hooks/useUnmatchTransactions"

/*
  INTERFACES
*/

interface Props {
  transactions: Transaction[] | FrontendTransaction
  onCancel: () => void
  onUnmatch?: (transactions: Transaction[]) => void
  onError?: (error: ApolloError) => void
}

/*
  COMPONENTS
*/

export const UnmatchModal: React.FC<Props> = ({ transactions, onUnmatch, onCancel, onError }) => {
  const unmatch = useUnmatchTransactions({ transactions, onUnmatch, onError })
  return (
    <AlertModal
      headerLabel="Unmatch Transactions"
      HeaderIcon={SvgLayersTwo02}
      primaryButtonLabel="Unmatch"
      primaryButtonClick={unmatch}
      secondaryButtonLabel="Cancel"
      secondaryButtonClick={onCancel}
    >
      Are you sure you would like to unmatch these transactions and book them as individual
      transactions?
    </AlertModal>
  )
}
